import React from 'react';

import {IconChevronRight} from '@veneer/core';

import {A} from '../../../../../Links';
import {IconMeta} from '../../../../utils/services/types';
import Icon from '../Icon/Icon';

import useStyles from './useStyles';

type BaseProps = {label: string; active?: boolean; icon: IconMeta};
type ButtonProps = {component: 'button'} & BaseProps & React.HTMLAttributes<HTMLButtonElement>;
type AnchorProps = {component: 'anchor'; href: string} & BaseProps & React.HTMLAttributes<HTMLAnchorElement>;

const MenuItem = (props: ButtonProps | AnchorProps) => {
    const {label, active = false, icon, ...rest} = props;

    const styles = useStyles(active);
    const args = rest;

    if (args.component === 'button') {
        // @ts-expect-error We don't want to pass this prop.
        delete args.component;

        return (
            <button
                className={styles.wrapper}
                {...args}
            >
                <div className={styles.label}>
                    <span className={styles.icon}>
                        <Icon icon={icon} />
                    </span>
                    <span className="subtitle-small">{label}</span>
                </div>
                <span>
                    <IconChevronRight
                        color="white"
                        size={16}
                    />
                </span>
            </button>
        );
    }

    // @ts-expect-error We don't want to pass this prop.
    delete args.component;

    return (
        <div>
            <A
                className={styles.wrapper}
                {...args}
            >
                <div className={styles.label}>
                    <span className={styles.icon}>
                        <Icon icon={icon} />
                    </span>
                    <span>{label}</span>
                </div>
            </A>
        </div>
    );
};

export default MenuItem;
